module.exports = __webpack_public_path__ + "img/salesman_index_banner.a2c3c598.png";